<template>
  <div :class="['container']">
    <div :class="$style.caption">{{ t('paymentTypes.text') }}</div>
    <div :class="$style.list">
      <img src="/images/payments/bitcoin.svg" alt="Visa" />
      <img src="/images/payments/tether.svg" alt="Visa" />
      <img src="/images/payments/etherium.svg" alt="Visa" />
      <img src="/images/payments/litecoin.svg" alt="Visa" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style lang="scss" module>
  .caption {
    margin: 40px 0 62px 0;
    text-align: center;
    color: #121E29;

    @media (max-width: 1023px) {
      margin: 60px 0 30px 0;
    }
  }

  .list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 72px;
    padding-bottom: 32px;

    @media (max-width: 1023px) {
      gap: 42px 64px;
    }

    img {
      height: 25px;
      width: auto;
      flex-shrink: 0;

      @media (max-width: 1023px) {
        height: 24px;
      }
    }
  }
</style>